import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import roleState from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import Service from '@/services/HttpRequestServiceWithToken'
import httpRequest from '@/services/HttpRequestServiceWithToken'

const baseUrl = process.env.VUE_APP_API_URL + '/v1/role'

const actions: ActionTree<roleState, State> = {

  async GetPermission(
    { commit, dispatch, state }: ActionContext<roleState, State>,
    option: object,
  ) {
    const response = await Service.get(
      process.env.VUE_APP_API_URL + '/v1/all/permission',
      option,
      (res: any) => {
        commit(mutationType.GET_LISTS, res)
        return res.result
      },
    )
    return response
  },
  async getuserByCenterList(
    { commit, dispatch, state }: ActionContext<roleState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1/', 'permission', options, (res: any) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
